var Isotope = require('isotope-layout');
var imagesLoaded = require('imagesloaded');

Masonry = function() {
  // // init Isotope
  // var grid = document.querySelector('.masogrid');

  // var iso = new Isotope(grid, {
  //   itemSelector: '.grid-item',
  //   percentPosition: true,
  //   masonry: {
  //     columnWidth: '.grid-sizer'
  //   }
  // });

  // var grid = document.querySelector('.masonry-grid');
  // var iso;

  // imagesLoaded(grid, function () {
  //   // init Isotope after all images have loaded
  //   iso = new Isotope(grid, {
  //     itemSelector: '.grid-item',
  //     percentPosition: true,
  //     transitionDuration: '0.2s',
  //     masonry: {
  //       columnWidth: '.grid-sizer'
  //     }
  //   });
  // });

  // // for each grid container
  var inputs = document.getElementsByClassName('masonry-grid');

  Array.prototype.forEach.call(inputs, function(el, index, array){
    var gridContainer = inputs[index];

    var iso = new Isotope( gridContainer, {
      itemSelector: '.grid-item',
      percentPosition: true,
      transitionDuration: '0.2s',
      masonry: {
        columnWidth: '.grid-sizer',
      }
    });

    imagesLoaded(gridContainer).on('progress', function () {
      // layout Isotope after each image loads
      iso.layout();
      console.log("loaded")
    });
  });
};
